AnnouncementsList = require 'models/collections/announcements-list'

module.exports = new AnnouncementsList [],
  requiresLogin: false
  dataUrl: '/announcements/all'



// WEBPACK FOOTER //
// ./app/scripts/models/all-announcements.coffee